import React from 'react';
import { barWidth, targetText } from './format';

/**
 * One metric: the result first (headline), then the count behind it, a bar
 * when it is a percentage, and the target when one is set. The whole card is a
 * button that opens the records behind it.
 */
const MetricCard = ({
  label,
  headline,
  unit,
  detail,
  percent,
  target,
  badge,
  alert = false,
  onClick
}) => {
  const short = target && target.variance < 0;
  return (
    <button
      type="button"
      onClick={onClick}
      className={`text-left bg-white rounded-2xl p-5 shadow-md flex flex-col gap-2.5 border transition-shadow hover:shadow-lg focus:outline-none focus-visible:ring-2 focus-visible:ring-[#1F4B55] ${
        alert ? 'border-red-300' : 'border-gray-200'
      }`}
    >
      <span className="flex justify-between w-full text-[13px] font-semibold text-gray-600">
        {label}
        <span className="text-[#1F4B55]">View ›</span>
      </span>
      <span className="flex items-baseline gap-2">
        <span className={`text-[34px] leading-none font-bold ${alert ? 'text-red-700' : 'text-black'}`}>
          {headline}
        </span>
        {unit && <span className="text-sm text-gray-600">{unit}</span>}
      </span>
      {detail && <span className="text-sm text-gray-700">{detail}</span>}
      {percent !== undefined && (
        <span className="block w-full h-2 bg-gray-200 rounded-full" aria-hidden="true">
          <span
            className="block h-2 bg-[#1F4B55] rounded-full"
            style={{ width: `${barWidth(percent)}%` }}
          />
        </span>
      )}
      {badge && (
        <span className="w-fit px-2.5 py-1 rounded-full text-[13px] font-semibold bg-red-50 text-red-700">
          {badge}
        </span>
      )}
      {target && (
        <span
          className={`w-fit px-2.5 py-1 rounded-full text-[13px] font-semibold ${
            short ? 'bg-orange-50 text-orange-800' : 'bg-green-50 text-green-800'
          }`}
        >
          {targetText(target)}
        </span>
      )}
    </button>
  );
};

export default MetricCard;
